module.exports = __webpack_public_path__ + "static/Portrait-of-Benjamin-min-fcba6ac05dc00ab931d756e49cb79975.jpg";